var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.RSVcreneau") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c("hr", { staticClass: "mx-auto" }),
        _vm._v(" "),
        _c("div", { staticClass: "container" }, [
          _vm.hasValidCurrentSession
            ? _c("div", { staticClass: "current-session-message" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("calendar.message_current_session")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "calendar-navigation" }, [
            _c("button", { on: { click: _vm.previousYear } }, [_vm._v("<")]),
            _vm._v(" "),
            _c("span", { staticClass: "calendar-year" }, [
              _vm._v(_vm._s(_vm.currentYear)),
            ]),
            _vm._v(" "),
            _c("button", { on: { click: _vm.nextYear } }, [_vm._v(">")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "calendar-container" }, [
            _c("table", { staticClass: "calendar-table" }, [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _c("th", { staticClass: "month-header" }, [
                      _vm._v(_vm._s(_vm.$t("calendar.month"))),
                    ]),
                    _vm._v(" "),
                    _vm._l(31, function (day) {
                      return _c("th", { key: day, staticClass: "day-header" }, [
                        _vm._v(_vm._s(day)),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.calendarData, function (days, monthKey, index) {
                  return _c(
                    "tr",
                    { key: monthKey },
                    [
                      _c("td", { staticClass: "month-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(`calendar.months.${_vm.monthKeys[index]}`)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(days, function (date, idx) {
                        return _c(
                          "td",
                          {
                            key: idx,
                            class: {
                              "out-of-month": date.isOutOfMonth,
                              "current-session": date.isInCurrentSession,
                              selected: date.isSelected,
                              weekend:
                                date.isWeekend &&
                                !date.isInCurrentSession &&
                                !date.isSelected,
                              "non-bookable":
                                date.isNonBookable &&
                                !(
                                  date.isWeekend &&
                                  (date.isInCurrentSession || date.isSelected)
                                ),
                              clickable:
                                (!date.isNonBookable &&
                                  !date.isOutOfMonth &&
                                  !date.isWeekend) ||
                                date.isInCurrentSession,
                            },
                            attrs: { title: date.dayName },
                            on: {
                              click: function ($event) {
                                return _vm.selectDate(date)
                              },
                            },
                          },
                          [
                            date.isSelected
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      date.isInCurrentSession || date.isSelected
                                        ? date.dayName
                                        : date.day
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "calendar-legend" }, [
            _c("div", { staticClass: "legend-item" }, [
              _c("div", { staticClass: "legend-color disabled" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("calendar.legend_unavailable"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "legend-item" }, [
              _c("div", { staticClass: "legend-color clickable" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("calendar.legend_available")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "legend-item" }, [
              _c("div", { staticClass: "legend-color current-session" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("calendar.legend_current")))]),
            ]),
          ]),
          _vm._v(" "),
          _vm.sessionToDelete
            ? _c(
                "div",
                {
                  staticStyle: { "text-align": "right", "margin-top": "20px" },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btnFilter_2",
                      on: { click: _vm.openConfirmDeleteSession },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.sessionIsInProgress
                              ? _vm.$t("calendar.stop_session")
                              : _vm.$t("calendar.cancel_session")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedDate
            ? _c(
                "div",
                { staticClass: "button-group" },
                [
                  _vm.selectedSession
                    ? [
                        _c(
                          "b-button",
                          {
                            staticClass: "btnFilter_2 mx-3",
                            on: { click: _vm.showSessionDetails },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("calendar.session_detail")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c(
                          "b-button",
                          {
                            staticClass: "btnFilter_2 mx-3",
                            on: { click: _vm.confirmReservation },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("calendar.confirm")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "btnFilter_2",
                            on: { click: _vm.cancelReservation },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("calendar.cancel")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }